<template>
  <div class="logo" :class="{ large: largeLogo }">
    <img alt="Jeep logo" src="../assets/logo.svg" :class="{ 'large': $route.path != '/' || $route.path != '/register' || $route.path != '/forgot' || $route.path != '/confirm' }">
  </div>
</template>

<script>
export default {
  name: 'Logo',
  data () {
    return {
      largeLogo: false
    }
  },
  watch: {
    '$route' () {
      if (/^\/(register|forgot|confirm)?$/.test(this.$route.path)) {
        this.largeLogo = true
      } else {
        this.largeLogo = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/variables.scss";
.logo {
  width: 100%;
  height: $header-height;
  padding: 30px 0 15px;

  img {
    display: block;
    max-height: 55px;
    margin: 0 auto;
  }
}

.logo.large {
  img {
    max-height: 84px;
  }
}
</style>
